import React, { useState } from 'react';
import { ChevronDown, ChevronUp, BoxIcon } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/Card';
import { Button } from './ui/Button';
interface CompetencyCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  projects: string[];
  tools: string[];
  achievements: string[];
}
export function CompetencyCard({
  title,
  description,
  icon: Icon,
  projects,
  tools,
  achievements
}: CompetencyCardProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <Card className="transition-all duration-300 hover:shadow-md border-l-4 border-l-primary/50 hover:border-l-primary" data-id="element-37">
      <CardHeader className="cursor-pointer" onClick={() => setIsExpanded(!isExpanded)} data-id="element-38">
        <div className="flex items-center justify-between" data-id="element-39">
          <div className="flex items-center gap-4" data-id="element-40">
            <div className="p-2 rounded-full bg-primary/10 text-primary" data-id="element-41">
              <Icon className="w-6 h-6" data-id="element-42" />
            </div>
            <div data-id="element-43">
              <CardTitle data-id="element-44">{title}</CardTitle>
              <CardDescription className="mt-1" data-id="element-45">{description}</CardDescription>
            </div>
          </div>
          <Button variant="ghost" size="icon" aria-label={isExpanded ? 'Collapse' : 'Expand'} data-id="element-46">
            {isExpanded ? <ChevronUp className="w-4 h-4" data-id="element-47" /> : <ChevronDown className="w-4 h-4" data-id="element-48" />}
          </Button>
        </div>
      </CardHeader>

      {isExpanded && <CardContent className="animate-accordion-down overflow-hidden" data-id="element-49">
          <div className="pt-2 space-y-6 border-t mt-2" data-id="element-50">
            <div data-id="element-51">
              <h4 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground mb-3" data-id="element-52">
                Key Projects
              </h4>
              <ul className="space-y-2" data-id="element-53">
                {projects.map((project, idx) => <li key={idx} className="flex items-start gap-2 text-sm" data-id="element-54">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 shrink-0" data-id="element-55" />
                    {project}
                  </li>)}
              </ul>
            </div>

            <div data-id="element-56">
              <h4 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground mb-3" data-id="element-57">
                Tools & Tech
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-58">
                {tools.map((tool, idx) => <span key={idx} className="px-2.5 py-1 rounded-md bg-secondary text-secondary-foreground text-xs font-medium" data-id="element-59">
                    {tool}
                  </span>)}
              </div>
            </div>

            <div data-id="element-60">
              <h4 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground mb-3" data-id="element-61">
                Achievements
              </h4>
              <ul className="space-y-2" data-id="element-62">
                {achievements.map((achievement, idx) => <li key={idx} className="flex items-start gap-2 text-sm" data-id="element-63">
                    <span className="text-green-500 font-bold" data-id="element-64">✓</span>
                    {achievement}
                  </li>)}
              </ul>
            </div>
          </div>
        </CardContent>}
    </Card>;
}